import { formAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle } = createMultiStyleConfigHelpers(formAnatomy.keys);

export const futureVariant = definePartsStyle(() => {
    return {
        container: {
            control: {
                textAlign: 'left',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
            },

            label: {
                color: 'general.subtext',
                fontSize: 'lg',
                fontWeight: 'normal',
                mb: '6',
            },

            'input, textarea': {
                display: 'flex',
                width: 'full',
                padding: '5 4',
                flexShrink: 0,
                borderRadius: '0.3rem',
                border: '1px solid',
                borderColor: '#94A7B0',
                background: 'white',
                color: 'general.subtext',
            },

            'input:focus, textarea:focus': {
                borderColor: 'general.inputFocus',
                borderWidth: '2px',
                color: 'general.inputFocus',
            },

            input: {
                height: '5.6rem',
            },

            textarea: {
                padding: '5',
            },
        },
    };
});
